import React from 'react'
import ArrowIcon from './icons/ArrowIcon'

const TransactionType = ({type}) => {
  return (
    <span className='p-[7px] text-xs rounded bg-gray-50 flex items-center gap-x-[7px] capitalize font-[500]'>
        <ArrowIcon className={`w-3 h-3 ${(type.toLowerCase() === 'credit' || type.toLowerCase() === 'funding') ? 'text-green-500 rotate-90' : '-rotate-90 text-red-500'}`} />

        {/* <span className={`inline-block w-[5px] h-[5px] rounded-full ${(type.toLowerCase() === 'credit' || type.toLowerCase() === 'funding') ? 'bg-green-500' : 'bg-red-500' }`} /> */}
        {type.toLowerCase()}
    </span>
  )
}

export default TransactionType